import { render, staticRenderFns } from "./EliminacionResiduosPagination.vue?vue&type=template&id=8fb9c422&"
import script from "./EliminacionResiduosPagination.vue?vue&type=script&lang=js&"
export * from "./EliminacionResiduosPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports